import React from "react";
import { IconProps } from "@src/lib/icons/types";

const PromptTypeShortResponseIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="19"
        height="18"
        fill="none"
        viewBox="0 0 19 18"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          d="M3.25 15.25C3.25 15.25 6.849 14.682 7.796 13.735C8.743 12.788 15.123 6.40799 15.123 6.40799C15.96 5.57099 15.96 4.21399 15.123 3.37799C14.286 2.54099 12.929 2.54099 12.093 3.37799C12.093 3.37799 5.713 9.75799 4.766 10.705C3.819 11.652 3.251 15.251 3.251 15.251L3.25 15.25Z"
          fill={color}
          fillOpacity="0.2"
        />
        <path
          d="M3.25 15.25C3.25 15.25 6.849 14.682 7.796 13.735C8.743 12.788 15.123 6.40799 15.123 6.40799C15.96 5.57099 15.96 4.21399 15.123 3.37799C14.286 2.54099 12.929 2.54099 12.093 3.37799C12.093 3.37799 5.713 9.75799 4.766 10.705C3.819 11.652 3.251 15.251 3.251 15.251L3.25 15.25Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 15.25H15.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default PromptTypeShortResponseIcon;
